import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { UserAuthService } from '../_services/user-auth.service';
import { UserLegalType } from '../enums/user-legal-type.enum';

export const userLegalTypeGuard: CanActivateFn = (route) => {
  const authService = inject(UserAuthService);
  const router = inject(Router);
  const typeMismatchRedirection = route.data['typeMismatchRedirection'] as string;
  const legalType = route.data['legalType'] as UserLegalType;
  const toastr = inject(ToastrService);
  const silentRedirection = route.data['silentRedirection'] as boolean;

  if (authService.isUserLoggedIn() && authService.getCurrentUser().userLegalType !== legalType) {
    if (!silentRedirection) {
      const legalTypeLabel =
        legalType === UserLegalType.COMPANY ? $localize`entreprises` : $localize`particuliers`;
      const errorMessage = $localize`Cette fonctionnalité n'est accessible qu'aux`;
      toastr.error(`${errorMessage} ${legalTypeLabel}`);
    }
    router.navigateByUrl(typeMismatchRedirection, { replaceUrl: true, state: { force: true } });
    return false;
  }
  return true;
};
